import { render } from "./ProductUpdate.vue?vue&type=template&id=7a6b7430&scoped=true"
import script from "./ProductUpdate.vue?vue&type=script&lang=js"
export * from "./ProductUpdate.vue?vue&type=script&lang=js"

import "./ProductUpdate.vue?vue&type=style&index=0&id=7a6b7430&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a6b7430"]])

export default __exports__